const u = (id, w = 1200) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=75`;

export const THEMES = {
  mehendi: {
    code: "MEH", label: "The Carnival",
    headline: "Let the madness begin!",
    tagline: "Good music. Great food. Questionable dance moves.",
    bg: "#F7B733", fg: "#3B0A2A", accent: "#D6246E", accent2: "#1FA7A0", soft: "#FFE7AE",
    palette: ["#D6246E", "#F7B733", "#FF6657", "#1FA7A0"],
    titleClass: "font-display italic", imgClass: "rounded-t-[999px]",
    image: u("1699764681875-dd04ce36b1c3"),
    moodboard: [u("1560505605-f300b17028d6", 800), u("1503160865267-af4660ce7bf2", 800), u("1692054631975-a734715f4a79", 800)],
    women: "Lehengas, shararas or breezy co-ords in your brightest brights. Florals? Groundbreaking, and very welcome.",
    men: "Printed kurtas, linen sets, a Nehru jacket if you're feeling fancy. Colour is strongly encouraged.",
    note: "It's poolside, so comfy footwear wins.",
  },
  wedding: {
    code: "WED", label: "The Big Moment",
    headline: "The moment we've been waiting for.",
    tagline: "Under the mandap, surrounded by everyone we love.",
    bg: "#FBF5EA", fg: "#2F3A2E", accent: "#6F8B6B", accent2: "#C6A46C", soft: "#F7DCE0",
    palette: ["#FBF5EA", "#A9C79D", "#F7C9D0", "#C6A46C"],
    titleClass: "font-display", imgClass: "rounded-t-[999px]",
    image: u("1772127822562-a898d9f5733c"),
    moodboard: [u("1737514996816-a034a795febe", 800), u("1729347917808-e3e35a462fec", 800), u("1587271636175-90d58cdad458", 800)],
    women: "Sarees or lehengas in soft pastels, ivory, blush and sage.",
    men: "Sherwanis, bandhgalas or kurta sets in light, muted tones.",
    note: "It's on the lawn, so light fabrics are your best friend.",
  },
  reception: {
    code: "REC", label: "Dressed to Impress",
    headline: "A little sparkle. A lot of celebration.",
    tagline: "Black tie, bright lights and a dance floor with your name on it.",
    bg: "#21191E", fg: "#F3E9DA", accent: "#C6A46C", accent2: "#E9D3A6", soft: "#2E2329",
    palette: ["#21191E", "#C6A46C", "#F3E9DA", "#44253D"],
    titleClass: "font-display uppercase tracking-[0.06em]", imgClass: "",
    image: u("1769981493694-0560b2ac128b"),
    moodboard: [u("1589212987511-4a924cb9d8ac", 800), u("1783923134298-5a202299a7c4", 800), u("1559753217-bbb7d4ffc9d5", 800)],
    women: "Gowns, cocktail sarees or sharp Indo-western.",
    men: "Tuxedos, black bandhgalas or a very, very good suit.",
    note: "When in doubt: black, gold and a little shine.",
  },
  sangeet: {
    code: "SAN", label: "11:11 | The Art of Timing",
    headline: "Lights. Music. A little Bollywood magic.",
    tagline: "The timing was perfect. The dance moves? We'll find out.",
    bg: "#44253D", fg: "#FCE9D8", accent: "#F2A541", accent2: "#E0558A", soft: "#55304C",
    palette: ["#44253D", "#A62D58", "#F2A541", "#FCE9D8"],
    titleClass: "font-display italic", imgClass: "rounded-full",
    image: u("1561212856-44e9bae482aa"),
    moodboard: [u("1756483488645-5973a1a92e33", 800), u("1785671053282-b734d6d4fafe", 800), u("1601922046210-41e129a3e64a", 800)],
    women: "Sequins, jewel tones and earrings that make a statement.",
    men: "Velvet bandhgalas, embellished jackets, kurtas with attitude.",
    note: "You will dance. Choose shoes accordingly.",
  },
};

export const themeFor = (slug) => THEMES[slug] || THEMES.wedding;

export const pick = (e, field, themeKey) => (e && e[field]) || themeFor(e?.slug)[themeKey || field];
